/**
 * PHASE3_MYNUMBER_UI_STUB
 *
 * マイナンバー管理画面（CBK-CBN-RD-BO-005）の本実装が終わるまで、
 * CloudFront `/mynumber*` の端末制限・オフィス IP 制限を確認するための到達スタブ。
 * 本実装の一覧・詳細を載せたら、このディレクトリと Pages/index.tsx・Header.tsx の参照を削除する。
 */
import {FC, useEffect, useState} from 'react'
import {Helmet} from 'react-helmet'
import {Alert, Container} from 'react-bootstrap'
import {useTRPC} from 'backoffice/ui/App'

export const PHASE3_MYNUMBER_UI_STUB = true

type PingState = 'loading' | 'ok' | 'error'

export const MynumberStubPage: FC = () => {
  const tRPC = useTRPC()
  const [ping, setPing] = useState<PingState>('loading')
  const [pingError, setPingError] = useState('')

  useEffect(() => {
    tRPC.mynumber.ping.query()
        .then(() => setPing('ok'))
        .catch((err: unknown) => {
          setPing('error')
          setPingError(err instanceof Error ? err.message : String(err))
        })
  }, [tRPC])

  return (
      <Container className="py-4">
        <Helmet>
          <title>マイナンバー（Phase3 スタブ）</title>
        </Helmet>
        <Alert variant="warning">
          これは Phase3 の到達確認用スタブです。マイナンバー管理画面の本実装後に削除してください（PHASE3_MYNUMBER_UI_STUB）。
        </Alert>
        <p>画面パス <code>/mynumber</code> に到達できています（CloudFront の端末制限・オフィス IP を通過）。</p>
        {ping === 'loading' && <p>マイナンバー向け API（ping）を確認しています…</p>}
        {ping === 'ok' && <p>マイナンバー向け API（ping）も成功しました。</p>}
        {ping === 'error' && (
            <Alert variant="danger">
              マイナンバー向け API（ping）が失敗しました: {pingError}
            </Alert>
        )}
      </Container>
  )
}
